var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mb-3"},[_c('gl-icon',{attrs:{"height":16,"name":_vm.getIcon,"width":16}}),_c('div',{staticClass:"validate-block-message ml-2",class:{
      'warning-text-red': !_vm.valid && _vm.turnOn,
      'white-space-pre-line': _vm.preLineMsg,
    }},[_vm._v(" "+_vm._s(_vm.msg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }